import { useToggleCountryStatus } from '../hooks/useToggleCountryStatus';
import { ConfirmDialog } from '@/shared/components/ahkinia/ConfirmDialog/ConfirmDialog';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';

interface ToggleCountryModalProps {
  countryId: string;
  countryName: string;
  currentStatus: boolean;
  open: boolean;
  onClose: () => void;
}

export function ToggleCountryModal({
  countryId,
  countryName,
  currentStatus,
  open,
  onClose,
}: ToggleCountryModalProps) {
  const { toggleStatus, isToggling } = useToggleCountryStatus();

  const isEnabling = !currentStatus;
  const newStatus = !currentStatus;

  const handleConfirm = () => {
    toggleStatus(
      { id: countryId, isActive: newStatus, cascade: 'both' },
      {
        onSuccess: () => {
          Notification.success({
            title: newStatus ? 'País habilitado exitosamente' : 'País deshabilitado exitosamente',
          });
          onClose();
        },
      },
    );
  };

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(v) => !v && onClose()}
      title={isEnabling ? 'Habilitar país' : 'Deshabilitar país'}
      description={
        <span data-testid="toggle-country-confirmation-text">
          ¿Estás seguro de {isEnabling ? 'habilitar' : 'deshabilitar'} el país{' '}
          <strong>{countryName}</strong>?
        </span>
      }
      onConfirm={handleConfirm}
      confirmLabel={isEnabling ? 'Habilitar' : 'Deshabilitar'}
      confirmLoadingLabel={isEnabling ? 'Habilitando...' : 'Deshabilitando...'}
      isPending={isToggling}
      data-testid="toggle-country-modal"
    >
      {!isEnabling && (
        <div
          data-testid="toggle-country-warning"
          className="p-3 bg-destructive/10 border border-destructive/30 rounded-md"
        >
          <p className="text-sm text-destructive font-medium">
            Advertencia: Esto deshabilitará todas las regiones asociadas y todos los estados,
            municipios y localidades del país.
          </p>
        </div>
      )}
      {isEnabling && (
        <div className="p-3 bg-primary/10 border border-primary/30 rounded-md">
          <p className="text-sm text-primary">
            Nota: También se habilitarán todos los estados, municipios y localidades del país. Las
            regiones no se habilitarán automáticamente; deberás habilitarlas de forma manual si lo
            deseas.
          </p>
        </div>
      )}
    </ConfirmDialog>
  );
}
